export const TOP_BANNER_NAMES = [
  '[Coleção] Banner',
  '[Coleção] Banner V2',
] as const

export const SEO_FAQ_SECTION_NAME = '[Campanhas 2.0] Conteúdo SEO & FAQ'

export type PlpCmsSection = {
  name: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data?: any
}

const isTopBannerName = (name: string): boolean =>
  (TOP_BANNER_NAMES as readonly string[]).includes(name)

const hasBannerImage = (data?: Record<string, unknown> | null): boolean =>
  Boolean(data?.imageBannerDesktop || data?.imageBannerMobile)

const isActiveTopBanner = (section: PlpCmsSection): boolean =>
  section.data?.enableSession === true && hasBannerImage(section.data)

export function withListingHeading(
  sections: PlpCmsSection[],
  listingName: string
): PlpCmsSection[] {
  let headingAssigned = false

  return sections.map((section) => {
    if (!isTopBannerName(section.name)) {
      return section
    }

    const showListingH1 = isActiveTopBanner(section) && !headingAssigned

    if (showListingH1) {
      headingAssigned = true
    }

    return {
      ...section,
      data: {
        ...(section.data ?? {}),
        listingName,
        showListingH1,
      },
    }
  })
}

export function splitSeoFaqSections(sections: PlpCmsSection[]): {
  aboveGallery: PlpCmsSection[]
  belowGallery: PlpCmsSection[]
} {
  const aboveGallery: PlpCmsSection[] = []
  const belowGallery: PlpCmsSection[] = []

  for (const section of sections) {
    if (section.name === SEO_FAQ_SECTION_NAME) {
      belowGallery.push({
        ...section,
        data: {
          ...(section.data ?? {}),
          layout: 'listing',
        },
      })
      continue
    }

    aboveGallery.push(section)
  }

  return { aboveGallery, belowGallery }
}
